// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"P2-z"};